function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#052D6B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.354 11.854L13.354 19.854C13.3076 19.9005 13.2524 19.9374 13.1917 19.9626C13.131 19.9877 13.066 20.0007 13.0003 20.0007C12.9346 20.0007 12.8695 19.9877 12.8088 19.9626C12.7481 19.9374 12.693 19.9005 12.6465 19.854L9.14653 16.354C9.05271 16.2602 9 16.133 9 16.0003C9 15.8676 9.05271 15.7403 9.14653 15.6465C9.24035 15.5527 9.3676 15.5 9.50028 15.5C9.63296 15.5 9.76021 15.5527 9.85403 15.6465L13.0003 18.7934L20.6465 11.1465C20.7403 11.0527 20.8676 11 21.0003 11C21.133 11 21.2602 11.0527 21.354 11.1465C21.4478 11.2403 21.5006 11.3676 21.5006 11.5003C21.5006 11.633 21.4478 11.7602 21.354 11.854Z",
  fill: "white"
});

var SvgBlueCheck = function SvgBlueCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blue-check.41f95957.svg";
export { ForwardRef as ReactComponent };